<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Reasons are added in a dialog on the list (STG-WEB-16). Old links land on
// the list; a named redirect keeps the :org param.
definePage({
  redirect: { name: '/(app)/[org]/settings/(organizations)/shift-reasons' },
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
  },
})
</script>

<template>
  <div />
</template>
